// Najdi prvek s třídou isOpenInfo
const isOpenInfoElement = document.querySelector("#top_menu .isOpenInfo");

// Najdi obsah span.openTimes
let openTimesText = document.querySelector("span.openTimes").innerHTML.trim();
// let openTimesText = "";
let todaysOpeningHours = "";
// document.addEventListener("DOMContentLoaded", function () {
//     const el = document.querySelector("span.openTimes");
//     if (el) {
//         const openTimesText = el.innerHTML.trim();
//         // console.log('openTimesText', openTimesText);
//     } else {
//         console.warn("Element span.openTimes nebyl nalezen.");
//     }
// });


// Získání aktuálního dne v týdnu
const currentDay = new Date().getDay(); // 0 = Neděle, 1 = Pondělí, ..., 6 = Sobota
todaysOpeningHours = getOpeningHoursForToday(openTimesText);
console.log("Dnešní otevírací hodiny:", todaysOpeningHours);
console.log("Dnešní otevírací openTimesText:", openTimesText);
// Funkce pro získání otevíracích hodin pro aktuální den
function getOpeningHoursForToday(openTimes) {
    // Rozděl řetězec podle nových řádků (nyní se jedná o skutečné nové řádky)
    const lines = openTimes.split("\n");

    let hours = "";

    if (currentDay >= 1 && currentDay <= 5) {
        // Pondělí až Pátek
        hours = lines[0].replace(/.*(\d{2}):\d{2}–(\d{2}):\d{2}.*/, "$1-$2");
    } else if (currentDay === 6 || currentDay === 0) {
        // Sobota a Neděle
        hours = lines[1].replace(/.*(\d{2}):\d{2}–(\d{2}):\d{2}.*/, "$1-$2");
    }

    return hours; // Vrátí jen čas ve formátu 09-20 nebo 10-18
}

// Získání otevíracích hodin pro dnešní den
// if (openTimesText !== undefined) {

// } else {
// }

// Najdi cílové prvky, kde chceš vložit text
const targetElement1 = document.querySelector("#top_menu > div > div.right > a:nth-child(1)");
//const targetElement2 = document.querySelector("body > div.footer_2024 > div.footer__inner > div:nth-child(2) > div > div:nth-child(3) > ul > li:nth-child(1) > a");
const targetElement2 = document.querySelector("div.footer_2024 > div.footer__inner.container > div:nth-child(2) > div > div:nth-child(3) > ul > li:nth-child(1) > a");
//#page > div.footer_2024 > div.footer__inner.container > div: nth - child(2) > div > div: nth - child(3) > ul > li: nth - child(1) > a


const targetElement3 = document.querySelector(
    "#page .cmsContent h3.font-size-24"
);

// Funkce pro přidání textu do span uvnitř targetElementu
function addOpeningHoursToTarget(targetElement, text) {
    if (targetElement) {
        let span = targetElement.querySelector("span"); // Zkontroluje, jestli span existuje
        if (!span) {
            span = document.createElement("span"); // Vytvoří span, pokud neexistuje
            targetElement.appendChild(span);
        }
        span.textContent = "(" + text + ")"; // Přidá nebo přepíše obsah spanu
    }
}

// Přidej otevírací hodiny do targetElement1 a targetElement2
addOpeningHoursToTarget(isOpenInfoElement, todaysOpeningHours);
// addOpeningHoursToTarget(isOpenInfoElement, todaysOpeningHours);

// Přidání isOpenInfoElement na místo cílových prvků
if (isOpenInfoElement && targetElement1 && targetElement2) {
    isOpenInfoElement.style.display = "inline-flex"; // Nastaví display inline pro isOpenInfoElement

    // Vložení do targetElement1
    targetElement1.appendChild(isOpenInfoElement.cloneNode(true)); // Klonování pro vložení

    // Vložení do targetElement2
    targetElement2.appendChild(isOpenInfoElement.cloneNode(true)); // Klonování pro vložení
}

if (isOpenInfoElement && targetElement3) {
    targetElement3.appendChild(isOpenInfoElement.cloneNode(true)); // Klonování pro vložení
}

if (isOpenInfoElement) {
    isOpenInfoElement.remove();
}
